var _rect, _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgPop = function SvgPop(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 32,
    height: 32,
    rx: 16,
    fill: "currentColor"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#pop_svg__a)",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M19.384 14.378a3.69 3.69 0 1 0 0-7.378 3.69 3.69 0 0 0 0 7.378ZM12.966 20.54c-.49 0-.95.19-1.296.537l-.453.453a.65.65 0 0 1-.917-.918l.5-.5c.435.155.934.089 1.319-.212l5.83-4.55a4.85 4.85 0 0 1-2.01-1.213 4.85 4.85 0 0 1-1.215-2.012l-4.55 5.83c-.3.386-.367.885-.212 1.32l-.5.5a1.836 1.836 0 0 0 0 2.593 1.836 1.836 0 0 0 2.593 0l.453-.453a.65.65 0 0 1 .917.918l-1.33 1.33.838.838 1.33-1.33a1.836 1.836 0 0 0-1.296-3.131Z"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "pop_svg__a"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    transform: "translate(7 7)",
    d: "M0 0h18v18H0z"
  })))));
};
export default SvgPop;